const C = require("../constants");

const cancelSale = (data) => {
    return {
        type: C.SHOW_CANCEL_SALE_ALERT,
        data
    }
};

export {cancelSale};


// WEBPACK FOOTER //
// ./src/actions/AlertCancelSaleAction.js